import { IconButton, SearchIcon } from "@carbon6/c6-frontend-design";
import type { Dataset } from "../../domain/dataset";
import { DatasetRowActionsMenu } from "./DatasetRowActionsMenu";
import styles from "./DatasetDetailActions.module.css";

type DatasetDetailActionsProps = {
  dataset: Dataset;
  onRequestProbe: () => void;
  onCopySourceRef: () => void;
  onHide: () => void;
  onShow: () => void;
};

/** 상세의 헤더 액션 — route 페이지의 `headerActions` 와 창의 `headerActions` 가 같은 것을 그린다. */
export function DatasetDetailActions({
  dataset,
  onCopySourceRef,
  onHide,
  onRequestProbe,
  onShow,
}: DatasetDetailActionsProps) {
  return (
    <div className={styles.actions}>
      <IconButton text="Probe 요청" tone="primary" variant="solid" onClick={onRequestProbe}>
        <SearchIcon />
      </IconButton>
      <DatasetRowActionsMenu
        dataset={dataset}
        onCopySourceRef={onCopySourceRef}
        onHide={onHide}
        onShow={onShow}
      />
    </div>
  );
}
